module.exports = __webpack_public_path__ + "static/media/Banner3.cc1f6d02.png";